import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "analytics-dashboard" }
const _hoisted_2 = { class: "top-container" }

import DashboardCalendar from './components/DashboardCalendar.vue'
import DashboardFilters from './components/DashboardFilters.vue'
import DashboardFilterResult from './components/DashboardFilterResult.vue'
import CollapseController from './components/CollapseController/CollapseController.vue'
import UnderlineTabGroup from '@/design-system/molecules/UnderlineTabGroup.vue'
import { ref, watch, inject, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { sharedDataKey } from '../types'
import { useI18n } from 'vue-i18n'
import useFeatures from '@/pinia/features'
import FeatureComponent from '../FeatureComponent.vue'
import { useCurrentFeatureFilters } from '@/composables/useFilters'
import { useResultReportNew } from './useResultReport'
import { InformationResponse, LocaleString } from '@/api-client/models/utilization/Contracts'
import { useStore } from 'vuex'
import { useTransferState } from './useTransferState'
import { storeToRefs } from 'pinia'
import { useInformation } from '@/pinia/information'

type Emits = {
  (e: 'toggleFullscreen'): void
  (e: 'closeDashboard'): void
}
type Props = {
  title: LocaleString
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardFeatureUsage',
  props: {
    title: {}
  },
  emits: ["toggleFullscreen", "closeDashboard"],
  setup(__props: any) {





function presentCalendar() {
  isPresentingCalendar.value = true
}

const { t } = useI18n()
const features = useFeatures()
const { pushFeature, replaceFeature } = features
const route = useRoute()

const sharedData = inject(sharedDataKey)
const buttons = [
  {
    text: t('dashboard__text__measurement_values'),
    name: 'kpis',
    onClick: () => {
      replaceFeature('kpis')
    }
  },
  {
    text: t('dashboard__text__chart-graphs'),
    name: 'graphs',
    onClick: () => {
      replaceFeature('graphs')
    }
  },
  {
    text: t('dashboard__text__chart-heatmaps'),
    name: 'heatmaps',
    onClick: () => {
      replaceFeature('heatmaps')
    }
  }
]

const store = useStore()
useTransferState(store)
const filters = useCurrentFeatureFilters()
const isPresentingExpandedFilters = ref(false)
const isPresentingCalendar = ref(false)

const { submitted } = storeToRefs(useInformation())
const data = computed(() => submitted.value?.data)
const isLoading = computed(() => submitted.value?.isLoading ?? true)
const { raw } = useResultReportNew(data)

watch(data, () => {
  if (data.value && 'numberOf' in data.value) {
    filters.value?.updateInformationResponse({
      buildings: data.value.numberOf?.CONSTRUCTION,
      rooms: 'SPACE' in data.value.numberOf ? data.value.numberOf.SPACE : undefined
    })
  }
})

watch(
  () => route.path,
  (path) => {
    if (path.endsWith('usage')) {
      pushFeature('kpis')
    }
  },
  { immediate: true }
)

onMounted(() => sharedData?.updateSectionIndex(0))

const submitForm = () => {
  isPresentingExpandedFilters.value = false
  filters.value?.submit()
}
const submitCalendarForm = () => {
  isPresentingCalendar.value = false
  filters.value?.submit()
}
const computedClass = computed(() => {
  return {
    fullscreen: sharedData?.fullscreen
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DashboardFilterResult, {
        information: isLoading.value ? undefined : data.value,
        style: 'margin-bottom: 8px;'
      }, null, 8, ["information"]),
      _createVNode(CollapseController, {
        isCollapsed: !isPresentingExpandedFilters.value,
        showCalendar: true,
        onPresentCalendar: presentCalendar,
        onToggleCollapse: _cache[0] || (_cache[0] = () => (isPresentingExpandedFilters.value = !isPresentingExpandedFilters.value))
      }, null, 8, ["isCollapsed"])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "horizontal-divider" }, null, -1)),
    _createElementVNode("div", {
      class: _normalizeClass(["scrollable-container", computedClass.value])
    }, [
      _createVNode(DashboardFilters, {
        information: (data.value as InformationResponse),
        isCollapsed: !isPresentingExpandedFilters.value,
        onResetForm: _unref(filters)?.$reset,
        onSubmitForm: submitForm
      }, null, 8, ["information", "isCollapsed", "onResetForm"]),
      _createVNode(UnderlineTabGroup, {
        buttons: buttons,
        size: 'small',
        style: 'margin-top: 16px;',
        "selected-name": _unref(route).path.split('/').pop()
      }, null, 8, ["selected-name"]),
      _createVNode(FeatureComponent, {
        feature: "home/analytics/analyticareas/usage/*",
        isMissingData: _unref(raw).spaces === 0
      }, null, 8, ["isMissingData"])
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "#home" }, [
      (isPresentingCalendar.value)
        ? (_openBlock(), _createBlock(DashboardCalendar, {
            key: 0,
            onCalendarClose: _cache[1] || (_cache[1] = () => (isPresentingCalendar.value = false)),
            onCalendarSubmit: submitCalendarForm
          }))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})